import { useQuery } from "react-query";
import CategoryScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import React, { useState } from "react";
import { TModal } from "../../../types/common.type";
import utils from "../../../utils";
import {
  IDeterminePriceCategory,
  IRequestCategory,
} from "../../../types/category.interface";
import { CATEGORY_BASE } from "../../../values/dropdownItems";

const CompanyContainer = () => {
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] =
    useState<IDeterminePriceCategory>();
  const [requestCategory, setRequestCategory] = useState<IRequestCategory>({
    type: CATEGORY_BASE[0]._id,
  });

  const { userInfo } = React.useContext(Context.AppContext);
  const userInformation = userInfo?.data?.result;

  console.log(userInformation);

  const resultCategory = useQuery(
    [values.useQueryKeys.getAllCategory, requestCategory],
    () =>
      api.getMethod.common.findCategory({
        ...requestCategory,
      })
  );

  const updateCategoryPrice = async (CategoryInfo: any) => {
    setLoading(true);
    const result = await api.putMethod.company.updateCategoryPrice({
      prices: CategoryInfo,
      companyId: userInformation?._id,
    });
    if (result) {
      resultCategory.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };

  return (
    <Context.CategoryPriceScreen.Provider
      value={{
        resultCategory,
        requestCategory,
        setRequestCategory,
        showModal,
        setShowModal,
        selectedCategory,
        setSelectedCategory,
        loading,
        setLoading,
        updateCategoryPrice,
      }}
    >
      <CategoryScreen />
    </Context.CategoryPriceScreen.Provider>
  );
};

export default CompanyContainer;
